// extracted by mini-css-extract-plugin
export default {"container":"PairedFlucs_container__o8HIs","flucContainer":"PairedFlucs_flucContainer__aapdw","drift":"PairedFlucs_drift__JxtWZ","firm":"PairedFlucs_firm__1P2dL"};